export const fallbackLng = 'en';
export const languages = ['en', 'fr', 'vi', 'zh', 'ar', 'th', 'lo', 'kh'];
export const defaultNS = 'common';
export const cookieName = 'i18next';

// ----------------------------------------------------------------------

export function i18nOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    lng,
    fallbackLng,
    ns,
    defaultNS,
    fallbackNS: defaultNS,
    supportedLngs: languages,
  };
}

// ----------------------------------------------------------------------

export const changeLangMessages = {
  en: {
    success: 'Language has been changed!',
    error: 'Error changing language!',
    loading: 'Loading...',
  },
  vi: {
    success: 'Ngôn ngữ đã được thay đổi!',
    error: 'Lỗi khi thay đổi ngôn ngữ!',
    loading: 'Đang tải...',
  },
  fr: {
    success: 'La langue a été changée!',
    error: 'Erreur lors du changement de langue!',
    loading: 'Chargement...',
  },
  cn: {
    success: '语言已更改！',
    error: '更改语言时出错！',
    loading: '加载中...',
  },
  ar: {
    success: 'تم تغيير اللغة!',
    error: 'خطأ في تغيير اللغة!',
    loading: 'جارٍ التحميل...',
  },
  th: {
    success: 'เปลี่ยนภาษาเรียบร้อย!',
    error: 'เกิดข้อผิดพลาดในการเปลี่ยนภาษา!',
    loading: 'กำลังโหลด...',
  },
  lo: {
    success: 'ສະບາຍດີສຸດສາມາດປ່ຽນແປງໄດ້!',
    error: 'ລະບົບຂາຍບັນຫາການປ່ຽນສະກຸນຈາກຂໍ້ມູນຂາຍບັນຫາການປ່ຽນແປງໄດ້!',
    loading: 'ກໍາລັງໂຫຼດ...',
  },
  kh: {
    success: 'ជោគជ័យ! អ្នកអាចផ្លាស់ប្តូរបាន។',
    error: 'ប្រព័ន្ធមានបញ្ហាក្នុងការផ្លាស់ប្តូររូបិយប័ណ្ណពីទិន្នន័យលក់!',
    loading: 'កំពុងផ្ទុក...',
  },
};
